export default {"src":"https://images-cdn.curipod.com/d-23ae3965/_next/static/media/Teacher-StudentGif.ce5fb3a4.gif","height":660,"width":1730};